import createPersistedState from 'vuex-persistedstate'
import i18n, { selectedLocale } from '@/plugins/i18n'

const state = {
    locale: selectedLocale
}

const getters = {
    lang: state => {
      return state.locale;
    }
}
  
const mutations = {
    updateLocale(state, newLocale) {
        state.locale = newLocale
    }
}
 
const actions = {
    changeLocale({ commit }, newLocale) {
        i18n.locale = newLocale
        commit('updateLocale', newLocale)
    }    
}
  
const plugins = [createPersistedState()]    
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    plugins
}